import {SxProps, Theme} from '@mui/material';
import theme from '../../../../theme';

export const clientCardSx = {
    menuBtn: {
        width: '100%',
    },
    menuBtnText: {
        width: '100%',
        textAlign: 'start',
        fontSize: theme.spacing(14 / 8),
        fontWeight: 400,
        color: theme.palette.neutral[400],
    },
    iconBtn: {
        width: theme.spacing(20 / 8),
        height: theme.spacing(20 / 8),
        backgroundColor: 'transparent',
    },
    popover: {
        '& .MuiPaper-root': {
            maxWidth: theme.spacing(200 / 8),
            width: '100%',
            p: 1,
        },
    },
};

/** The title is the client's name and the way to them: a link that reads as the title. */
export const nameLinkSx: SxProps<Theme> = {
    color: 'inherit',
    textDecoration: 'none',
};

/** A fact whose value carries a control. A span, because a fact's value is drawn inside a paragraph. */
export const factWithActionSx: SxProps<Theme> = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
};
